import useStyles from "../../../style/js-style/containers/thirdparties/sheet/TPSheetStyle.js";
import { Box, Grid, Tooltip, Typography, useTheme } from '@mui/material';
import EAColorIcon from '../../common/EAColorIcon';
import i18next from 'i18next';
import { formatDate, getCountryName } from '../../../services/common/Utils';
import clsx from 'clsx';
import EAIcon from '../../common/EAIcon';
import React, { useContext } from 'react';
import EAFlag from '../../EAFlag';
import EAChip from '../../EAChip';
import EAChipWithBackground from '../../EAChipWithBackground';
import ThirdpartyCodeUpdate from '../ThirdpartyCodeUpdate';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import WarningIcon from '@mui/icons-material/WarningAmber';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import TooltipOnClick from '../../common/TooltipOnClick';
import { Context } from '../../../states/Store';
import UnmanagedBadge from "../unmanagedThirdParty/UnmanagedBadge.js";
import { PrivilegeEnum } from "services/common/RolesUtils.js";
import { errorColor, missingColor, orangeColor } from "style/globalStyle.js";

function HeaderInformation({ thirdparty,
  isUnmanaged,
  tpId,
  thirdpartyCode,
  setIsOpenInformationPopup,
  changeShownTpCode,
  fromSheet,
  denominationRef,
  hasAnyOfPrivilegesOnScopedResource}) {
  const { classes } = useStyles();

  const [isOpenEditCode, setIsOpenEditCode] = React.useState(false);
  const [hover, setHover] = React.useState(false);
  const theme = useTheme();
  const [state] = useContext(Context);

  function getLeiStatusIcon(status) {
    const s = (status || "").toLowerCase();
    const commonStyle = { position: 'relative', top: '-2px', left: '-2px' };
    if (s === "issued") {
      return (
        <CheckCircleIcon fontSize="small" sx={{ color: 'white', ...commonStyle, }} />
      );
    }
    if (["lapsed", "merged", "pending_transfer", "transferred", "pending_archival"].includes(s)) {
      return (
        <WarningIcon fontSize="small" sx={{ color: '#ff9800', ...commonStyle, top: "-4px" }} />
      );
    }
    if (["annulled", "duplicate", "retired"].includes(s)) {
      return (
        <CancelIcon fontSize="small" sx={{ color: '#f44336', ...commonStyle, }} />
      );
    }else {
      return (
        <HelpOutlineIcon fontSize="small" sx={{ color: '#607d8b', ...commonStyle }} />
      );
    }
  }

  const getAddress = () => {
    return <>
      {' '}
      {thirdparty.addressStreet || ""}
      {" " + (thirdparty.additionalAddressDetails || "")}
      {", " + (thirdparty.addressPostCode || "")} {thirdparty.addressCity || ""}
      {", " + getCountryName(thirdparty.addressCountryCode, i18next.language) || ""}
      {' '}
    </>
  }

  return (
    <>
      <div className={classes.overlay} style={{ backgroundColor: state.personalization.isCustomTemplate && thirdparty.onboarded ? theme.palette.primary.primary600 + "80" : "" }} />
      <Grid item xs={thirdparty.stoppingDate ? 8 : 12} style={{zIndex: 2}}>
        <div style={{ display: 'flex', gap: '16px' }}>
          {/* Date d'ajout */}
          <Typography
            variant="subtitle2"
            className={
              thirdparty.stoppingDate ? classes.archivedFontHeaderTheme : ''
            }
          >
            <EAColorIcon
              icon={'valid'}
              className={classes.topHeaderIcon}
              svgStyle={{ marginRight: '4px' }}
            />
            <span className={classes.addDate} style={{ color: 'white' }}>
              {i18next.t('dashboard.thirdparties.addAt')}{' '}
              {thirdparty.dateCreation && (
                <span className="dt">
                  {formatDate(thirdparty.followingDate)}
                </span>
              )}
            </span>
          </Typography>

          {/* Date d'arrêt */}
          {thirdparty.stoppingDate && !thirdparty.onboarded &&
            <Typography
              variant="subtitle2"
              className={
                !thirdparty.onboarded ? classes.archivedFontHeaderTheme : ''
              }
            >
              <EAColorIcon
                icon={'stop'}
                className={classes.topHeaderIcon}
                svgStyle={{ marginRight: '4px' }}
              />
              <span className={classes.addDate} style={{ color: 'white' }}>
                {i18next.t('dashboard.thirdparties.stopAt')}{' '}
                {thirdparty.stoppingDate && (
                  <span className="dt">
                    {formatDate(thirdparty.stoppingDate)}
                  </span>
                )}
              </span>
            </Typography>
          }
        </div>

        {/* Denomination */}
        <Typography
          variant="h1"
          className={thirdparty.onboarded ? '' : classes.archivedThemeHeader}
        >
          {' '}
          <div className={classes.tpNameWrapper} ref={denominationRef}>
            <span
              className={clsx(classes.thirdpartyName, 'dt')}
              style={{ color: 'white' }}
            >
              {thirdparty.name}
            </span>{' '}
            {isUnmanaged && (
              <UnmanagedBadge />
            )}


          </div>
        </Typography>

        {/* Activité */}
        {thirdparty.etabActivityLabel && (
          <div className={classes.activityLabelWrapper}>
            <Typography
              variant="subtitle2"
              className={clsx(
                thirdparty.onboarded
                  ? classes.topHeaderLabelActivity
                  : classes.topHeaderLabelActivityArchived,
                'dt'
              )}
            >
              {thirdparty.etabActivityLabel}
            </Typography>
          </div>
        )}

        {/* Information + code tiers */}
        <div>
          <Grid
            container
            spacing={0}
            className={classes.thirdpartyTitleContainer}
          >
            <Grid item xs={12} md={12}>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="flex-start"
              >
                {/* Country flag */}
                <EAFlag countryCode={thirdparty.addressCountryCode} noBorder />

                {/* collective proceedings */}
                {thirdparty.thirdpartyAlerts &&
                  thirdparty.thirdpartyAlerts === "OUI" && (
                    <EAChipWithBackground
                      label={i18next.t("collectiveProceedingOngoing")}
                      color={orangeColor}
                    />
                  )}
                {thirdparty.thirdpartyAlerts &&
                  thirdparty.thirdpartyAlerts === "CLOTURÉE" && (
                    <EAChipWithBackground
                      label={i18next.t("collectiveProceedingClosed")}
                      color={errorColor}
                    />
                  )}

                {thirdparty.hasRestrictedDisclosure && (
                  <EAChipWithBackground
                    label={i18next.t("hasRestrictedDisclosure.title")}
                    color={missingColor}
                    tooltip={i18next.t("hasRestrictedDisclosure.tooltip")}
                  />
                )}

                {/* Headquarter*/}
                <EAChip
                  label={
                    thirdparty.headquarter
                      ? i18next.t('headquarters')
                      : i18next.t('secondaryBranch')
                  }
                  color={'white'}
                  fontWeight={700}
                />

                {/* Catégorie */}
                {thirdparty.category && (
                  <EAChip
                    label={i18next.t(
                      `misc.companyCategoryOptions.${thirdparty.category}`
                    )}
                    color={'white'}
                    fontWeight={700}
                  />
                )}

                {/* Code tiers */}
                <div
                  className={hasAnyOfPrivilegesOnScopedResource(
                            PrivilegeEnum.PRIVILEGE_EDIT_THIRD_PARTY_CODE
                          ) ? classes.tpCodeWrapper : classes.tpCodeDisabled}
                  onClick={hasAnyOfPrivilegesOnScopedResource(
                            PrivilegeEnum.PRIVILEGE_EDIT_THIRD_PARTY_CODE
                          ) ? () => setIsOpenEditCode(true) : null}
                >
                  {isOpenEditCode
                    ? (
                      <ThirdpartyCodeUpdate
                        tpCode={thirdpartyCode}
                        onTpCodeChange={changeShownTpCode}
                        handleClose={() => setIsOpenEditCode(false)}
                        thirdpartyId={tpId}
                      />
                    )
                    : (
                      <>
                        {thirdpartyCode || '-'} <b>({i18next.t('tpCode')})</b>

                        {hasAnyOfPrivilegesOnScopedResource(PrivilegeEnum.PRIVILEGE_EDIT_THIRD_PARTY_CODE ) &&
                          <EAIcon
                            icon={'edit_grey_full'}
                            className={classes.tpCodeIcon}
                          />
                        }
                      </>
                    )
                  }
                </div>
              </Box>
            </Grid>
          </Grid>
        </div>
      </Grid>

      {/* Tiers archivé : commentaire */}
      {thirdparty.stoppingDate && !thirdparty.onboarded &&
        <Grid item xs={thirdparty.stoppingDate ? 4 : 0}>
          <div className={fromSheet ? classes.archiveReasonWrapperOnSheet : classes.archiveReasonWrapper}>
            <div className={classes.archiveReasonTitleWrapper}>
              <EAIcon
                icon={'thirdparty-archive'}
                style={{ width: '50px', position: 'relative', top: '5px' }}
              />
              <div className={classes.archiveReasonTitle}>
                {i18next.t('dashboard.thirdparties.archived')}
              </div>
            </div>

            {thirdparty.stoppingReason &&
              <div className={classes.archiveReasonTextWrapper}>
                <b>{i18next.t('dashboard.thirdparties.comment')} : </b>
                <span>{thirdparty.stoppingReason || ''}</span>
              </div>
            }
          </div>
        </Grid>
      }

      <Grid item xs={12}>
        <hr
          style={{ width: tpId ? 'calc(100% + 36px)' : 'calc(100% + 16px)' }}
          className={classes.separatorHeader}
        />

        {/* Adresse + identifiant */}
        <div className={classes.adresseIdentifiersMoreDetailsWrapper}>
          <div className={classes.adresseIdentifiersWrapper}>
            <div>
              <Tooltip
                title={
                  <>
                    {i18next.t('thirdpartySheet.address')} : {getAddress()}
                  </>
                }
              >
                <div className={classes.typoLineWrapper} >
                  <Typography className={classes.typoLabel}>
                    {' '}
                    <EAColorIcon
                      icon={'coordinate'}
                      color={'#C6CBD9'}
                      svgStyle={{ position: 'relative', top: '2px' }}
                    />
                    {i18next.t('thirdpartySheet.address')} :{' '}
                  </Typography>
                  <Typography className={classes.typoContent}>
                    {getAddress()}
                  </Typography>
                  <br />
                </div>
              </Tooltip>
            </div>

            <div style={{ display: 'flex', gap: '20px' }}>
              {thirdparty.siret && (
                <TooltipOnClick
                  copyValue={thirdparty.siret}
                  children={
                    <div className={classes.idChipWrapper}>
                      <div className={classes.idChip}>
                        {thirdparty.siret} ({i18next.t('siret')})
                      </div>
                      <EAColorIcon icon={'content_copy'} svgStyle={{ position: 'relative', top: '2px' }} />
                    </div>
                  }
                />
              )}
              {thirdparty.tva && (
                <TooltipOnClick
                  copyValue={thirdparty.tva}
                  children={
                    <div className={classes.idChipWrapper} >
                      <div className={classes.idChip}>
                        {thirdparty.tva} ({i18next.t('VAT')})
                      </div>
                      <EAColorIcon icon={'content_copy'} svgStyle={{ position: 'relative', top: '2px' }} />
                    </div>
                  }
                />

              )}
              {!thirdparty.dunsEncrypted && thirdparty.duns && (
                <TooltipOnClick
                  copyValue={thirdparty.duns}
                  children={
                    <div className={classes.idChipWrapper}>
                      <div className={classes.idChip}>
                        {thirdparty.duns} ({i18next.t('DUNS')})
                      </div>
                      <EAColorIcon icon={'content_copy'} svgStyle={{ position: 'relative', top: '2px' }} />
                    </div>
                  }
                />

              )}
              {thirdparty.lei && (
                <TooltipOnClick
                  copyValue={thirdparty.lei}
                  children={
                    <div className={classes.idChipWrapper}>
                      <div style={{ position: 'relative' }} className={classes.idChip}>
                    <span style={{ position: 'absolute', top: '4px', width: '15px', height: '15px', backgroundColor: thirdparty.leiStatus === "issued" ? "#4caf50" : ["annulled", "duplicate", "retired"].includes(thirdparty.leiStatus) && 'white', borderRadius: "50%" }}>
                      <Tooltip title={i18next.t(`leiStatus.${thirdparty.leiStatus || 'UNKNOWN'}`)}>
                        {getLeiStatusIcon(thirdparty.leiStatus)}
                      </Tooltip>
                    </span>
                        <span style={{ paddingLeft: '25px' }}>{thirdparty.lei} (LEI)</span>
                      </div>
                      <EAColorIcon icon={'content_copy'} />
                    </div>
                  }
                />
              )}
            </div>
            </div>

            {/* EN savoir plus */}
            <div
              className={classes.moreDetailsWrapper}
              style={{ position: 'relative', left: fromSheet && thirdparty.stoppingDate ? "-20px" : 0}}
              onClick={() => setIsOpenInformationPopup(true)}
              onMouseEnter={() => setHover(true)}
              onMouseLeave={() => setHover(false)}
            >
            <span className={classes.moreDetailsText}>
              {i18next.t('moreDetails')}
            </span>
              <EAColorIcon
                icon={'call_made'}
                color={hover ? 'black' : 'white'}
                svgStyle={{ position: 'relative', top: '2px' }}
              />
            </div>

          </div>
      </Grid>
    </>
);
}

export default HeaderInformation;
